import { render, staticRenderFns } from "./HeaderProjects.vue?vue&type=template&id=397c0e3b&"
import script from "./HeaderProjects.vue?vue&type=script&lang=js&"
export * from "./HeaderProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports